if (!customElements.get('cnm-kids-pack')) {
  customElements.define('cnm-kids-pack', class extends HTMLElement {
    connectedCallback() {
      this.cakes = JSON.parse(this.querySelector('[data-cake-variants]').textContent);
      this.packs = JSON.parse(this.querySelector('[data-pack-variants]').textContent);
      this.words = JSON.parse(this.querySelector('[data-pack-words]').textContent);
      this.root = this.closest('product-info');
      this.mode = this.querySelector('[data-pack-mode]');
      this.choice = this.querySelector('[data-pack-choice]');
      this.update = () => this.sync();
      this.root.addEventListener('change', this.update);
      let scheduled = false;
      this.observer = new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        queueMicrotask(() => { scheduled = false; if (this.isConnected) this.sync(); });
      });
      this.observer.observe(this.root, {childList:true, subtree:true, attributes:true, attributeFilter:['value']});
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.root?.removeEventListener('change', this.update);
    }
    sync() {
      const form = document.getElementById(this.dataset.formId);
      const cake = this.cakes.find(v => String(v.id) === String(form?.elements.namedItem('id')?.value));
      const servings = Number(cake?.options?.[0]?.match(/^\s*(\d+)\s*(?:pers|parts|servings)/i)?.[1]);
      const eligible = [8,12,18].includes(servings);
      this.hidden = !eligible;
      const matches = eligible ? this.packs.filter(v => Number(v.options[0].match(/^\s*(\d+)/)?.[1]) === servings) : [];
      const signature = matches.map(v => `${v.id}:${v.available}:${v.price}`).join('|');
      if (signature !== this.signature) {
        const accompaniment = this.choice.selectedOptions[0]?.dataset.accompaniment;
        this.choice.replaceChildren(...matches.map(v => {
          const option = document.createElement('option');
          const macarons = /macaron/i.test(v.options[1]);
          option.value = String(v.id);
          option.dataset.accompaniment = macarons ? 'macarons' : 'sables';
          option.textContent = macarons ? this.words.macarons : this.words.cookies;
          option.disabled = !v.available;
          return option;
        }));
        const next = [...this.choice.options].find(o => !o.disabled && o.dataset.accompaniment === accompaniment) || [...this.choice.options].find(o => !o.disabled);
        this.choice.value = next?.value || '';
        this.signature = signature;
      }
      this.mode.querySelector('[value="pack"]').disabled = !matches.some(v => v.available);
      if (!eligible || !matches.some(v => v.available)) this.mode.value = 'cake';
      const selected = eligible && this.mode.value === 'pack';
      this.choice.disabled = !selected;
      this.querySelector('[data-pack-details]').hidden = !selected;
      const pack = selected ? matches.find(v => String(v.id) === this.choice.value && v.available) : null;
      this.selectedPack = pack;
      this.selectedCake = cake;
      const price = pack?.price ?? cake?.price;
      const text = price == null ? '' : `${pack ? this.words.packTotal : this.words.cakeTotal} ${new Intl.NumberFormat(document.documentElement.lang || 'fr', {style:'currency', currency:this.dataset.currency}).format(price / 100)}`;
      const total = this.querySelector('[data-pack-total]');
      if (total.textContent !== text) total.textContent = text;
      this.root.querySelectorAll('[id^="price-"]').forEach(el => {
        if (selected && !el.hasAttribute('data-cnm-pack-price-hidden') && !el.hidden) { el.hidden = true; el.dataset.cnmPackPriceHidden = ''; }
        if (!selected && el.hasAttribute('data-cnm-pack-price-hidden')) { el.hidden = false; delete el.dataset.cnmPackPriceHidden; }
      });
    }
    prepareFormData(formData) {
      this.sync();
      if (this.mode.value !== 'pack') return formData;
      if (!this.selectedPack || !this.selectedCake || !this.selectedPack.available) throw new Error(this.words.unavailable);
      formData.set('id', String(this.selectedPack.id));
      formData.delete('selling_plan');
      formData.set('properties[Modèle du gâteau]', this.dataset.cakeTitle);
      formData.set('properties[Format du gâteau]', this.selectedCake.options[0]);
      formData.set('properties[Formule]', this.words.pack);
      formData.set('properties[Accompagnement]', this.choice.selectedOptions[0].textContent);
      formData.set('properties[_cnm_cake_variant]', String(this.selectedCake.id));
      formData.set('properties[_cnm_cake_url]', this.dataset.cakeUrl);
      return formData;
    }
  });
}
